const pagesPersonCsvImportEn = {
  breadcrumb: 'Add members by CSV',
  detail: {
    applyButton: 'Execute import',
    chunkLabel: 'Chunk {{index}}',
    chunkLoadError: 'Failed to load this chunk. Please try again.',
    chunkLoading: 'Loading chunk results...',
    chunkPanelTitle: 'Chunks',
    chunkRowsCount: '{{count}} rows',
    downloadErrorRowsButton: 'Download error rows',
    emptyRows: 'No matching rows',
    failureReason: {
      csvParseFailed: 'Failed to parse the CSV file. Please check the format.',
      emptyCsvFile: 'The CSV file is empty.',
      noValidRows: 'No valid rows to import. Fix the errors below and upload the file again.',
      unknown: 'The import failed. Please try again.'
    },
    progress: {
      errors: 'Errors',
      importedCount: 'Imported',
      importing: 'Importing data...',
      valid: 'Valid',
      validating: 'Checking the uploaded file...'
    },
    retryButton: 'Retry',
    rowNumberHeader: 'Row',
    toolbar: {
      errorChip: 'Error',
      noChangeChip: 'No changes',
      searchPlaceholder: 'Filter by name...',
      updatableChip: 'Updatable'
    }
  },
  dialog: {
    field: {
      boardMemberType: 'Board member type',
      collaboratorType: 'Collaborator type',
      contractTerm: 'Contract period',
      contractorType: 'Contractor type',
      employmentType: 'Employment type',
      joinDate: 'Join date',
      name: 'Name'
    },
    requiredLabel: 'Required',
    title: 'Select member type'
  },
  errors: {
    applyFailed: 'Failed to import the data. Please try again.',
    conflict: 'This file is already being processed.',
    enqueueFailed: 'Failed to start the import. Please try again.',
    notFound: 'The import could not be found.',
    templateDownloadFailed: 'Failed to download the template. Please try again.'
  },
  list: {
    bulkImportButton: 'Bulk Import {{memberType}}',
    bulkImportButtonAll: 'Bulk Import Members',
    columns: {
      fileName: 'Original data file',
      importedAt: 'Date',
      importedCount: 'Updated members',
      status: 'Status'
    },
    downloadTemplate: {
      downloadAll: 'Download all',
      trigger: 'Download template'
    },
    empty: 'No import history yet.',
    menuTabs: {
      import: 'Import'
    },
    pageDescription: 'You can add data for multiple people. A CSV file following the DRESS CODE format is required.',
    title: 'Bulk Data Import/Export Logs: People'
  },
  memberType: {
    all: 'All',
    boardMember: 'Board member',
    collaborator: 'Collaborator',
    contractor: 'Contractor',
    employee: 'Employee'
  },
  status: {
    applied: 'Import complete',
    applyFailed: 'Import failed',
    applying: 'Importing',
    partiallyApplied: 'Partially imported',
    validateFailed: 'Validation failed',
    validated: 'Awaiting review',
    validating: 'Validating'
  },
  stepper: {
    import: 'Import',
    preview: 'Preview',
    upload: 'Upload'
  },
  uploadDialog: {
    exportedDataFile: 'Exported data file',
    prepareFileDescription: "Download the latest exported data file and make any necessary updates on your computer. Once you're done, upload the updated file back to DRESS CODE.",
    prepareFileHeading: "If you haven't prepared the data file yet",
    startVerification: 'Start file verification',
    title: 'Upload {{memberType}} data to import'
  }
};
export default pagesPersonCsvImportEn;